<template>
  <div>
    <el-button
      round
      @click="handleClick()"
      :size="this.size"
      :type="this.type"
      v-if="theme === '2'"
      :class="this.className"
      :disabled="disabled"
      :style="[
        {
          backgroundColor: this.background ? this.background : uiVariable.color.backgroundGrey2,
          borderWidth: 1,
          borderColor: uiVariable.color.purple2,
          width: this.width,
          color: uiVariable.color.purple,
        },
        this.styles,
      ]"
    >
      <slot />
    </el-button>
    <el-button
      round
      @click="handleClick()"
      :size="this.size"
      :type="this.type"
      v-else-if="theme === '3'"
      :class="this.className"
      class="py-0 px-1"
      :disabled="disabled"
      :style="{ backgroundColor: 'transparent', borderWidth: 0, width: this.width }"
    >
      <slot />
    </el-button>
    <el-button
      round
      @click="handleClick()"
      :size="this.size"
      :type="this.type"
      v-else-if="this.type === 'danger'"
      :disabled="disabled"
      :style="{ width: this.width, color: 'white' }"
    >
      <slot />
    </el-button>
    <el-button
      @click="handleClick()"
      :size="this.size"
      :type="this.type"
      v-else-if="this.hideRound"
      :disabled="disabled"
      :style="{ backgroundColor: this.background, borderColor: this.background, width: this.width }"
    >
      <slot />
    </el-button>
    <el-button
      round
      @click="handleClick()"
      :size="this.size"
      :type="this.type"
      :disabled="disabled"
      v-else-if="plain"
      plain
      :style="{ backgroundColor: this.uiBackground, width: this.width, color: 'white', ...styles }"
    >
      <slot />
    </el-button>
    <el-button
      round
      @click="handleClick()"
      :size="this.size"
      :type="this.type"
      v-else
      :disabled="disabled"
      :style="{ backgroundColor: this.uiBackground, width: this.width, color: 'white', ...styles }"
    >
      <slot />
    </el-button>
  </div>
</template>

<script>
import uiVariable from '../../config/uiVariable'

export default {
  name: 'K2Button',
  props: ['className', 'type', 'background', 'size', 'onclick', 'width', 'theme', 'styles', 'disabled', 'hideRound', 'plain'],
  watch: {
    background: function (value) {
      this.uiBackground = value
    },
  },
  components: {},
  data() {
    return {
      uiVariable: uiVariable,
      uiBackground: this.background,
    }
  },
  created() {
    if (!this.type && !this.background) {
      this.uiBackground = uiVariable.color.button1
    }
  },
  methods: {
    handleClick() {
      this.$emit('onclick')
    },
  },
}
</script>
